// extracted by mini-css-extract-plugin
module.exports = {"hero":"Page404_hero__37u87","container":"Page404_container__2kAq7","main":"Page404_main__2xzc8","btn":"Page404_btn__2zDzC"};